<div class="dialog-container" [ngClass]="{'qualifying-questions-mode': showQualifyingQuestions}">
  <div class="dialog-header">
    <!-- Back button - only show when showQualifyingQuestions is true -->
    <button *ngIf="showQualifyingQuestions" class="back-btn" (click)="onBack()" aria-label="Go back" type="button">
      <img src="assets/images/Backicon.svg" alt="Back" width="20" height="20">
    </button>

    <span class="header-title">Start New Application</span>

    <button *ngIf="!showQualifyingQuestions" class="close-btn" (click)="onCancel()" aria-label="Close dialog" tabindex="0" type="button">
      <span class="close-x-icon" aria-hidden="true">
        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
          <line x1="2" y1="2" x2="10" y2="10" stroke="#444444" stroke-width="1.5" stroke-linecap="round"/>
          <line x1="10" y1="2" x2="2" y2="10" stroke="#444444" stroke-width="1.5" stroke-linecap="round"/>
        </svg>
      </span>
    </button>
  </div>
  <hr>

  <!-- Original Application Type Selection View -->
  <div *ngIf="!showQualifyingQuestions" class="dialog-content" [ngStyle]="errorMessage ? {'padding-top': '10px'} : {}">
    <ng-container *ngIf="applicationTypesReady">
      <label for="appType" class="dialog-label">Select an application type to continue.<span class="required-asterisk">*</span></label>
      <div class="radio-group">
        <div *ngFor="let list of applicationTypes" class="radio-item">
            <input
              type="radio"
              name="applicationType"
              [value]="list.key"
              [(ngModel)]="selectedType"
              id="appType-{{list.key}}"
              (change)="errorMessage = ''"
            />
          <label class="option-display" [for]="'appType-' + list.key">{{ list.value }}</label>
        </div>
      </div>
      <div *ngIf="errorMessage" style="color: #d32f2f; font-size: 14px; margin-top: 4px;">{{ errorMessage }}</div>
    </ng-container>
  </div>

  <!-- Qualifying Questions View -->
  <div *ngIf="showQualifyingQuestions" class="dialog-content" style="padding-top: 10px;">
    <!-- Download License Button - positioned below hr and above heading -->
    <div class="download-license-container">
      <button
        type="button"
        class="download-license-btn"
        (click)="downloadLicense()"
        aria-label="Download License as PDF"
        title="Download License">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          aria-hidden="true">
          <path
            d="M12 15.4115C11.8795 15.4115 11.7673 15.3923 11.6635 15.3538C11.5597 15.3154 11.4609 15.2494 11.3672 15.1558L8.25775 12.0463C8.10908 11.8974 8.03567 11.7233 8.0375 11.524C8.0395 11.3247 8.11292 11.1474 8.25775 10.9922C8.41292 10.8373 8.59108 10.7572 8.79225 10.752C8.99358 10.7468 9.17183 10.8218 9.327 10.977L11.25 12.9V5.25C11.25 5.03717 11.3218 4.859 11.4655 4.7155C11.609 4.57183 11.7872 4.5 12 4.5C12.2128 4.5 12.391 4.57183 12.5345 4.7155C12.6782 4.859 12.75 5.03717 12.75 5.25V12.9L14.673 10.977C14.8218 10.8283 14.9984 10.7549 15.2028 10.7568C15.4072 10.7588 15.5871 10.8373 15.7423 10.9922C15.8871 11.1474 15.9621 11.3231 15.9672 11.5192C15.9724 11.7154 15.8974 11.8911 15.7423 12.0463L12.6328 15.1558C12.5391 15.2494 12.4403 15.3154 12.3365 15.3538C12.2327 15.3923 12.1205 15.4115 12 15.4115ZM6.30775 19.5C5.80258 19.5 5.375 19.325 5.025 18.975C4.675 18.625 4.5 18.1974 4.5 17.6923V15.7308C4.5 15.5179 4.57183 15.3398 4.7155 15.1962C4.859 15.0526 5.03717 14.9808 5.25 14.9808C5.46283 14.9808 5.641 15.0526 5.7845 15.1962C5.92817 15.3398 6 15.5179 6 15.7308V17.6923C6 17.7692 6.03208 17.8398 6.09625 17.9038C6.16025 17.9679 6.23075 18 6.30775 18H17.6923C17.7692 18 17.8398 17.9679 17.9038 17.9038C17.9679 17.8398 18 17.7692 18 17.6923V15.7308C18 15.5179 18.0718 15.3398 18.2155 15.1962C18.359 15.0526 18.5372 14.9808 18.75 14.9808C18.9628 14.9808 19.141 15.0526 19.2845 15.1962C19.4282 15.3398 19.5 15.5179 19.5 15.7308V17.6923C19.5 18.1974 19.325 18.625 18.975 18.975C18.625 19.325 18.1974 19.5 17.6923 19.5H6.30775Z"
            fill="currentColor" />
        </svg>
        <span>Download License</span>
      </button>
    </div>

    <!-- Subheading for RCR flow -->
    <div style="font-size: 16px; font-weight: 600; color: #333; margin-bottom: 16px;">Renew, Convert or Re-Apply – Qualifying Questions:</div>

    <!-- Global Error Message -->
    <div *ngIf="qualifyingGlobalError" style="background-color: #fdecea; border: 1px solid #d32f2f; border-radius: 4px; padding: 12px; margin-bottom: 16px;">
      <div style="display: flex; align-items: flex-start;">
        <span style="color: #d32f2f; font-size: 20px; margin-right: 8px;">✕</span>
        <div>
          <div style="color: #d32f2f; font-weight: 600; margin-bottom: 4px;">
            {{ errorMessages['M0160'] || 'You cannot proceed with a new application.' }}
          </div>
          <div style="color: #333; font-size: 14px;">
            {{ errorMessages['M0161'] || 'One or more required conditions have not been completed. Please fulfill all licensure requirements before attempting to renew, convert, or reapply.' }}
          </div>
        </div>
      </div>
    </div>

    <!-- Questions List -->
    <div *ngFor="let question of qualifyingQuestions; let i = index">
      <!-- Only show questions that are in visibleQuestionIndices -->
      <div *ngIf="visibleQuestionIndices.includes(i)" style="margin-bottom: 20px;">
        <div style="font-size: 16px; color: #333; margin-bottom: 8px;">{{ question }}<span class="requiredfield text-danger">*</span></div>
        <div style="display: flex; gap: 20px; margin-bottom: 4px;">
          <label style="display: flex; align-items: center; cursor: pointer;">
            <input 
              type="radio" 
              [name]="'question-' + i" 
              [value]="'yes'"
              [checked]="qualifyingAnswers[i] === 'yes'"
              (change)="onAnswerChange(i, 'yes')"
              style="margin-right: 8px;"
            />
            <span>Yes</span>
          </label>
          <label style="display: flex; align-items: center; cursor: pointer;">
            <input 
              type="radio" 
              [name]="'question-' + i" 
              [value]="'no'"
              [checked]="qualifyingAnswers[i] === 'no'"
              (change)="onAnswerChange(i, 'no')"
              style="margin-right: 8px;"
            />
            <span>No</span>
          </label>
          <label *ngIf="question.includes('License Requirements') || question.includes('License Provisions') || question.includes('Professional Development requirements')" style="display: flex; align-items: center; cursor: pointer;">
            <input 
              type="radio" 
              [name]="'question-' + i" 
              [value]="'not applicable'"
              [checked]="qualifyingAnswers[i] === 'not applicable'"
              (change)="onAnswerChange(i, 'not applicable')"
              style="margin-right: 8px;"
            />
            <span>Not Applicable</span>
          </label>
        </div>
        <!-- Question-level error -->
        <div *ngIf="qualifyingErrors[i]" style="color: #d32f2f; font-size: 14px; margin-top: 4px;">
          {{ errorMessages[qualifyingErrors[i]] || 'Please select an answer.' }}
        </div>

        <!-- ARL Program Fields - Show only for question with key '2' when answered Yes -->
        <div *ngIf="showArlProgramFields && qualifyingQuestionKeys[i] === '2'" class="arl-program-fields">
          <!-- Provider Name - Full width row -->
          <div class="arl-provider-row">
            <div class="arl-field">
              <label class="arl-field-label">Provider Name</label>
              <select
                name="arlProviderName"
                [(ngModel)]="arlProviderName" 
                class="arl-field-select arl-provider-select"
                [title]="arlProviderName || ''"
                disabled
              >
                <option [value]="null" disabled selected hidden>{{ placeholderMessage['P0138'] }}</option>
                <option *ngFor="let option of arlProviderOptions" [value]="option.value">{{ option.value }}</option>
              </select>
            </div>
          </div>

          <!-- Program Area and Date of Completion - Side by side row -->
          <div class="arl-fields-container">
            <!-- Program Area -->
            <div class="arl-field">
              <label class="arl-field-label">Program Area<span class="required-asterisk">*</span></label>
              <select 
                [(ngModel)]="arlProgramArea" 
                class="arl-field-select" 
                (blur)="validateArlProgramArea()"
                (ngModelChange)="validateArlProgramArea()"
                [ngClass]="{'is-invalid': arlProgramAreaTouched && arlProgramAreaError, 'placeholder-shown': arlProgramArea === null}"
              >
                <option [value]="null" disabled selected hidden>{{ placeholderMessage['P0123'] }}</option>
                <option *ngFor="let option of arlProgramAreaOptions" [value]="option.key">{{ option.value }}</option>
              </select>
              <div *ngIf="arlProgramAreaTouched && arlProgramAreaError" class="text-danger mt-1 err-font">
                {{ errorMessages[arlProgramAreaError] || 'Please select a program area.' }}
              </div>
            </div>

            <!-- Date of Completion -->
            <div class="arl-field">
              <label class="arl-field-label">Date of Completion<span class="required-asterisk">*</span></label>
              <div class="input-group arl-date-input-group">
                <input 
                  type="text" 
                  id="arlCompletionDateInput"
                  [(ngModel)]="arlCompletionDate" 
                  class="arl-field-date"
                  [placeholder]="placeholderMessage['P0124'] || 'MM/DD/YYYY'"
                  data-placeholder="MM/DD/YYYY"
                  maxlength="10"
                  (blur)="validateArlCompletionDate()"
                  (input)="formatArlDateInput($event)"
                  (ngModelChange)="validateArlCompletionDate()"
                  [ngClass]="{'is-invalid': arlCompletionDateTouched && arlCompletionDateError}"
                />
                <span class="arl-calendar-icon">
                  <button 
                    type="button" 
                    class="btn p-0 calendar-btn" 
                    (click)="openArlDatePicker($event)"
                    (keypress)="openArlDatePicker($event)"
                    title="Open Calendar" 
                    aria-label="Open date picker"
                    tabindex="-1">
                    <span class="material-symbols-outlined f-20 cal">
                      calendar_month
                    </span>
                  </button>
                </span>
              </div>
              <div *ngIf="arlCompletionDateTouched && arlCompletionDateError" class="text-danger mt-1 err-font">
                {{ errorMessages[arlCompletionDateError] || 'Please enter a valid date.' }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <hr>
  <div class="dialog-actions">
    <button class="cancel-btn" (click)="onCancel()">Cancel Application</button>
<button 
      *ngIf="!showQualifyingQuestions"
      class="continue-btn" 
      (click)="onContinue()"
      [disabled]="isCreatingApplication || !selectedType">
      Proceed to Application
    </button>
    <button 
      *ngIf="showQualifyingQuestions"
      class="continue-btn" 
      [disabled]="qualifyingGlobalError !== null || !areAllVisibleQuestionsAnswered"
      (click)="onQualifyingContinue()">
      Proceed to Application
    </button>
  </div>
</div>
 